module.exports = __webpack_public_path__ + "img/variable-statement.52142524.svg";